import { t } from "i18next";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { AppConfig } from "../../../../../api/config/config";
import EmptyImage from "../../../../../assets/images/icons/feather_upload-cloud.svg";
import { GeneralMessage } from "../../../../../components";
import { FILETYPES } from "../../../../../Constants/fileConstants";
import { useAppSelector } from "../../../../../hooks";
import { IStepFields } from "../../../../../interface/MedicalRecord";
import { getFileCount } from "../../../../../redux/reducers/investigationFilesSlice";
import InvestigationInputModal from "./InvestigationInputModal";
import UploadedFileCard from "./UploadedFileCard";

interface AddInvestigationInputProps {
  field: IStepFields;
  disabled?: boolean;
}

const defaultMaxCount = 12

const AddInvestigationInput: React.FC<AddInvestigationInputProps> = ({
  field,
  disabled,
}) => {
  const [isAddNewOpen, setIsAddNewOpen] = useState(false);

  const { watch } = useFormContext();


  const maxFiles = Number(AppConfig.MAX_MEDICAL_FILE_COUNT) ?? defaultMaxCount

  const totalUploaded = useAppSelector(getFileCount());
  const limitReached = totalUploaded >= maxFiles;
  const name = `Attributes.${String(field?.Id)}`;

  const options = `Attributes.${String(field?.Id)}-option`;

  const uploadedFilesOption = watch(options)




  const renderUploader = () => {
    return <div
      onClick={() => !disabled && setIsAddNewOpen(true)}
      className={`flex h-20 w-full items-center gap-4 rounded-lg border border-dashed border-radio p-4 ${disabled ? "" : "cursor-pointer"}`}
    >
      <img alt="empty" className="max-w-12" src={EmptyImage} />
      <div className="flex flex-col gap-1">
        <h3>{t("upload_files_here")}</h3>
        <p className="text-body-text">{FILETYPES}</p>
      </div>
      {isAddNewOpen && (
        <InvestigationInputModal
          fieldConfig={field}
          isOpen={isAddNewOpen}
          onClose={() => setIsAddNewOpen(false)}
          name={name}
          disabled={false}
        />
      )}
    </div>
  }


  const renderUploadedCards = () => {
    return (
      <div className="flex flex-col gap-2">
        {uploadedFilesOption?.map((file: any) =>
          <UploadedFileCard field={field}
            item={file}
          />

        )}
      </div>
    );
  };

  return (
    <div className="w-full py-3">
      {field?.Name && (
        <div className="py-2">
          <h4 className="text-lg font-bold">{field.Name}</h4>
        </div>
      )}

      {!limitReached ? <div className={disabled ? "opacity-30" : "mb-2"}>
        {renderUploader()}
      </div> :
        <>
          <GeneralMessage
            status="warning"
            className="flex mb-3 !max-h-40 !items-start justify-center text-center"
            message={t("max_uploaded_files_reached")}
          /></>}

      {renderUploadedCards()}
    </div>
  );
};

export default AddInvestigationInput;
